module.exports = __webpack_public_path__ + "img/file-icon.c8d972d5.png";